import { utils } from 'zksync-ethers';
import { ETH_ADDRESS_IN_CONTRACTS } from 'zksync-ethers/build-esm/utils';
import { BridgeMiddleware as BridgeMiddlewareAbi, ERC20 as ERC20Abi, } from '../abis';
import { ETH_DECIMALS } from '../config/constants';
import { executeTx, getContract } from '../utils';
import { L2GasEstimator } from './l2GasEstimator';
export class BridgeMiddleware {
    constructor({ signerOrProvider, l1providerOptions, l2providerOptions, contractAddressMap, }) {
        this.signerOrProvider = signerOrProvider;
        this.l2GasEstimator = new L2GasEstimator(l1providerOptions, l2providerOptions, contractAddressMap, signerOrProvider);
        this.contractAddressMap = contractAddressMap;
        this.middleware = this.createMiddlewareContract();
    }
    async depositToken(_depositorAddress, _depositTokenAddress, amount) {
        const { isEth, depositorAddress, depositTokenAddress, amountBigInt, l2GasLimit, l2GasPerPubdataByteLimit, value, } = await this.getDepositParams(_depositorAddress, _depositTokenAddress, amount);
        if (!isEth) {
            const tokenContract = getContract(depositTokenAddress, ERC20Abi, this.signerOrProvider);
            const allowanceOfUser = await tokenContract.allowance(depositorAddress, this.middleware.getAddress());
            if (allowanceOfUser < amountBigInt) {
                const tx = tokenContract.approve(this.middleware.getAddress(), amountBigInt);
                await executeTx(tx);
            }
        }
        const tx = this.middleware.bridge(depositorAddress, depositTokenAddress, amountBigInt, l2GasLimit, l2GasPerPubdataByteLimit, depositorAddress, { value });
        return await executeTx(tx);
    }
    async getDepositParams(depositorAddress, _depositTokenAddress, amount) {
        const isEth = _depositTokenAddress === this.contractAddressMap.ETH;
        const depositTokenAddress = isEth
            ? ETH_ADDRESS_IN_CONTRACTS
            : _depositTokenAddress;
        const decimals = await (async () => {
            if (isEth) {
                return BigInt(ETH_DECIMALS);
            }
            const tokenContract = getContract(depositTokenAddress, ERC20Abi, this.signerOrProvider);
            return tokenContract.decimals();
        })();
        const { l2TxCostInETH, l2GasLimit } = await this.l2GasEstimator.getL2GasEstimate({
            depositorAddress,
            depositTokenAddress,
            decimals,
            amount,
        });
        const amountBigInt = amount.shl(Number(decimals)).quotient;
        return {
            isEth,
            depositorAddress,
            l2TxCostInETH,
            l2GasLimit,
            decimals,
            depositTokenAddress,
            amountBigInt,
            value: isEth ? l2TxCostInETH + amountBigInt : l2TxCostInETH,
            l2GasPerPubdataByteLimit: utils.REQUIRED_L1_TO_L2_GAS_PER_PUBDATA_LIMIT,
        };
    }
    createMiddlewareContract() {
        return getContract(this.contractAddressMap.BridgeMiddleware, BridgeMiddlewareAbi, this.signerOrProvider);
    }
}
